import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const SignInPageExtension = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        auto
        provider={{
          apiRef: microsoftAuthApiRef,
          id: 'microsoft-auth-provider',
          message: 'Sign in using Azure',
          title: 'Authentication',
        }}
      />
    ),
  },
});
